import React from 'react';
import { useNavigate } from "react-router-dom";
import { TournamentNewsItem } from '../../utils/apiClient';

export type TournamentStatus = 'active' | 'upcoming' | 'past';

const STATUS_LABEL: Record<TournamentStatus, string> = {
  active: 'Регистрация открыта',
  upcoming: 'Скоро старт',
  past: 'Завершён',
};

const MONTHS_SHORT = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

export const TournamentCard = ({ tournament, status }: { tournament: TournamentNewsItem; status: TournamentStatus }) => {
  const navigate = useNavigate();

  const start = tournament.startDate ? new Date(tournament.startDate) : undefined;
  const end = tournament.endDate ? new Date(tournament.endDate) : undefined;

  const dateRange = start
    ? (end && end.toDateString() !== start.toDateString())
      ? `${start.toLocaleDateString('ru-RU')} – ${end.toLocaleDateString('ru-RU')}`
      : start.toLocaleDateString('ru-RU')
    : undefined;

  return (
    <div
      className={`tournament-row tournament-row--${status}`}
      onClick={() => navigate(`/tournaments/${tournament.id}`)}
    >
      <div className="tournament-row__date">
        <span className="tournament-row__day">{start ? start.getDate() : '—'}</span>
        <span className="tournament-row__month">{start ? MONTHS_SHORT[start.getMonth()] : ''}</span>
      </div>

      <div className="tournament-row__body">
        <div className="tournament-row__title-line">
          <h3 className="tournament-row__title">{tournament.name}</h3>
          <span className="tournament-row__status">{STATUS_LABEL[status]}</span>
        </div>
        <div className="tournament-row__meta">
          {tournament.location && <span>{tournament.location}</span>}
          {dateRange && <span>{dateRange}</span>}
          {status === 'active' && tournament.registrationEndDate && (
            <span>Регистрация до {new Date(tournament.registrationEndDate).toLocaleDateString('ru-RU')}</span>
          )}
        </div>
      </div>

      <span className="tournament-row__arrow" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </span>
    </div>
  );
};
